module.exports = __webpack_public_path__ + "img/broker-user-icon.e3463cd8.svg";